import Alert from '@mui/material/Alert';
import { INTERVIEW_STEPS } from 'modules/hiring/shared/constants';
import {
  ContractRound,
  DataEntryRound,
  DocumentCollectionRound,
  InductionRound,
  InterviewRound1,
  InterviewRound2,
  InterviewRound3,
} from '../rounds';

const INTERVIEW_ROUND_COMPONENTS = {
  round1: InterviewRound1,
  round2: InterviewRound2,
  round3: InterviewRound3,
  offerLetter: InterviewRound3,
  onboarding: DataEntryRound,
  documentCollection: DocumentCollectionRound,
  contract: ContractRound,
  induction: InductionRound,
};

export default function InterviewContent({
  currentRound,
  viewedRound,
  interviewData,
  candidateData,
  onApprove,
  onReject,
}) {
  const viewedStepKey = INTERVIEW_STEPS[viewedRound]?.key;
  const RoundComponent = INTERVIEW_ROUND_COMPONENTS[viewedStepKey];

  const keyMap = {
    offerLetter: 'round3',
    onboarding: 'personalData',
  };

  const resolvedStepKey = keyMap[viewedStepKey] || viewedStepKey;

  if (!RoundComponent) {
    return <Alert severity='info'>No content for this round</Alert>;
  }

  const isPastRound = viewedRound < currentRound;

  const readOnlyStatus = ['pending', 'applied', 'rejected', 'hired'];
  const isContract = viewedStepKey === 'contract';
  const isReadOnly = isContract
    ? candidateData?.status === 'hired'
    : readOnlyStatus.includes(candidateData?.status) || isPastRound;

  return (
    <RoundComponent
      data={interviewData?.[resolvedStepKey]}
      interviewData={interviewData}
      candidateData={candidateData}
      readOnly={isReadOnly}
      currentRound={currentRound}
      viewedRound={viewedRound}
      onApprove={onApprove}
      onReject={onReject}
    />
  );
}
